var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"disabled":_vm.game === null},on:{"click":_vm.printMoves}},[_vm._v("Print Moves")])])}
var staticRenderFns = []

export { render, staticRenderFns }